import { Conditions } from '../../rules/Conditions';

export const AllowedInlineConditions = [
  Conditions.Item_Source,
  Conditions.Item_Sku,
  Conditions.Item_Name,
  Conditions.Item_MarketplaceService,
  Conditions.Item_TariffCode
];
